import React from 'react';

// Small mark-only logo shown in place of the full header + evaluator banner
// when the page is rendered for PDF export (see downloadPersonalisedPlanPdf.ts).
const PdfLogo: React.FC = () => (
  <div className="w-full flex items-center justify-center pt-[30px]">
    <svg
      width="31"
      height="19"
      viewBox="0 0 31 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="MyYogaTeacher"
    >
      <g clipPath="url(#clip0_4846_3515)">
        <path
          d="M22.3528 14.9479V12.7045C22.0497 12.7453 21.7831 12.8055 21.5541 12.8819C21.0811 13.0388 20.7651 13.2484 20.5297 13.5161C20.3738 13.6956 20.2481 13.9074 20.1524 14.1761C20.0234 14.5319 19.9492 14.9909 19.9492 15.5585V18.678H22.2786H22.3528H24.4124V18.1007C24.4124 18.1007 22.3625 17.8546 22.3528 14.9479Z"
          fill="#EE731B"
        />
        <path
          d="M14.3538 11.5339C14.3538 7.93064 11.7019 4.94766 8.24271 4.42846C8.24056 4.43276 8.23841 4.43706 8.23626 4.44136C7.87507 4.38332 7.50422 4.35107 7.12798 4.34892C3.34094 4.37042 0.248313 7.32115 0 11.0501H5.89717V11.0523C5.90792 11.0523 5.91759 11.0512 5.92727 11.0512C7.41177 11.0512 8.61679 12.2433 8.64044 13.7225H8.64366V14.9479C8.63399 17.8546 6.58298 18.1007 6.58298 18.1007V18.678H8.64366H8.71676H14.3559V11.7693H14.3506C14.3527 11.6908 14.3538 11.6123 14.3538 11.5339Z"
          fill="#EE731B"
        />
        <path
          d="M21.2863 11.2781C21.9205 11.1018 22.6311 11.0244 23.4308 11.0244H30.7082C30.5868 9.28948 29.8494 7.72542 28.7153 6.54728C27.4114 5.21542 25.5947 4.38878 23.5846 4.38878C22.0151 4.38878 20.565 4.89294 19.3826 5.74644C19.3579 5.76794 19.331 5.78729 19.303 5.80557C19.2934 5.81309 19.2837 5.81954 19.2729 5.82707L19.2708 5.82492C19.1525 5.89371 19.015 5.93349 18.8677 5.93349C18.4216 5.93349 18.0615 5.5723 18.0615 5.1262C18.0615 4.87896 18.1733 4.65752 18.3485 4.51025V4.50918C18.3506 4.50703 18.3528 4.50595 18.3549 4.5038C18.3786 4.48446 18.4033 4.46725 18.428 4.45006C19.3149 3.80724 20.3242 3.32566 21.4164 3.04725C19.9351 1.33808 17.7497 0.256681 15.3118 0.256681C12.9017 0.256681 10.7389 1.31228 9.2598 2.98705C13.1049 3.92763 15.9664 7.40294 15.9664 11.5329V11.5587H15.9686V18.677H18.3388V15.5575C18.3388 14.7663 18.4517 14.0493 18.7204 13.4141C18.987 12.7798 19.4267 12.2391 19.9975 11.8565C20.378 11.5995 20.8112 11.4103 21.2863 11.2781Z"
          fill="#EE731B"
        />
      </g>
      <defs>
        <clipPath id="clip0_4846_3515">
          <rect width="31" height="19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
);

export default PdfLogo;
